<template>
  <div class="main-container">

    <div class="container">
      <div class="column-75 page-middle">
        <h2>ENTER FOR A CHANCE TO WIN!</h2>
        <h4>Fill out the form below to be entered for a chance to win.</h4>
      </div>
    </div>  

    <form @submit.prevent="send_form()" action="" enctype="application/json" novalidate>

      <date_of_birth v-if="local_config.fields.date_of_birth" v-show="local_config.fields.date_of_birth.show"></date_of_birth>

      <!-- Personal data -->

      <div class="container">
        <first_name v-if="local_config.fields.first_name" v-show="local_config.fields.first_name.show"></first_name>
        <last_name v-if="local_config.fields.last_name" v-show="local_config.fields.last_name.show"></last_name>
      </div>  

      <div class="container">
        <state disabled="true" v-if="local_config.fields.state" v-show="local_config.fields.state.show"></state>
        <phone v-if="local_config.fields.phone" v-show="local_config.fields.phone.show"></phone>

      </div>  

      <div class="container">
        <email v-if="local_config.fields.email && local_config.fields.email.show"></email>
      </div>

      <div class="container">
        <address1 v-if="local_config.fields.address1" v-show="local_config.fields.address1.show"></address1>
        <address2 v-if="local_config.fields.address2" v-show="local_config.fields.address2.show"></address2>
      </div>

      <div class="container">
        <city v-if="local_config.fields.city" v-show="local_config.fields.city.show"></city>
        <zipcode v-if="local_config.fields.zipcode" v-show="local_config.fields.zipcode.show"></zipcode>
      </div> 

      <!--Checkboxes-->

      <tc_accepted v-if="local_config.fields.tc_accepted" v-show="local_config.fields.tc_accepted.show"></tc_accepted>
      <age_confirmed v-if="local_config.fields.age_confirmed" v-show="local_config.fields.age_confirmed.show"></age_confirmed>
      <privacy_policies_accepted v-if="local_config.fields.privacy_policies_accepted" v-show="local_config.fields.privacy_policies_accepted.show"></privacy_policies_accepted>
      <email_optin v-if="local_config.fields.email_optin" v-show="local_config.fields.email_optin.show"></email_optin>
      <sms_optin v-if="local_config.fields.sms_optin" v-show="local_config.fields.sms_optin.show"></sms_optin>

      <br><br><br>

      <button type="submit" :disabled="$store.state.loader">SUBMIT</button>

    </form>

  </div>
</template>

<script>
  import {
    fields,
    form_methods,
    requests_methods,
    validation,
  } from "../mixins/requests";
  import { elements_classes } from "../mixins/elements_classes";

  // FIELDS
  import date_of_birth from "../components/fields/date_of_birth";
  import state from "../components/fields/state";
  import first_name from "../components/fields/first_name";
  import last_name from "../components/fields/last_name";
  import email from "../components/fields/email";
  import phone from "../components/fields/phone";
  import zipcode from "../components/fields/zipcode";
  import address1 from "../components/fields/address1";
  import address2 from "../components/fields/address2";
  import city from "../components/fields/city";
  import tc_accepted from "../components/fields/tc_accepted";
  import age_confirmed from "../components/fields/age_confirmed";
  import privacy_policies_accepted from "../components/fields/privacy_policies_accepted";
  import email_optin from "../components/fields/email_optin";
  import sms_optin from "../components/fields/sms_optin";

  export default {
    name: "entry",
    mixins: [
      fields,
      form_methods,
      requests_methods,
      validation,
      elements_classes,
    ],
    components: {
      date_of_birth,
      state,
      first_name,
      last_name,
      email,
      phone,
      zipcode,
      address1,
      address2,
      city,
      tc_accepted,
      age_confirmed,
      privacy_policies_accepted,
      email_optin,
      sms_optin,
    },
    data() {
      return {
        // this_page: 'entry'
      };
    },
    computed: {
      this_page() {
        return this.$route.name;
      },
    },
    created() {},
  };
</script>

<style scoped>
</style>